import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import * as Sentry from '@sentry/browser'

import packageJson from '../package.json'
import { App } from './App'
import { configureStore } from './store'

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://022b29acd7064c9fbc7de1b3200522dd@o62714.ingest.sentry.io/5226635',
        release: `${packageJson.name}@${packageJson.version}`,
        environment: process.env.REACT_APP_APP_ENV,
    })
}

// The service worker is only emitted by `vite build` (see vite.config.ts), so the dev server doesn't serve it
if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_APP_ENV !== 'local' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js')
}

export const appRootId = 'app-root'
const container = document.getElementById(appRootId)

if (! container) {
    throw new Error(`Element with id "${appRootId}" not found in index.html`)
}

const root = createRoot(container)

configureStore({}).then(store => {
    root.render(
        <Provider store={store}>
            <App />
        </Provider>,
    )
})
